import { render, staticRenderFns } from "./KeyFiguresCard.vue?vue&type=template&id=709a29df"
import script from "./KeyFiguresCard.vue?vue&type=script&lang=js"
export * from "./KeyFiguresCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports